import { takeUntil } from 'rxjs/operators';

import type { WidgetEffectParams } from '@swf/core/store';
import { authChange } from '@swf/core/utils/actions';

import type { SportsPromotionDetailsWidgetConfig } from '../config';

import type { PromotionDetailsResponse, WidgetDispatch, WidgetSelect } from './types';

export const effects = {
  async preload(
    _payload: undefined,
    {
      actions,
      dispatch,
      rootState,
      select,
      widget
    }: WidgetEffectParams<SportsPromotionDetailsWidgetConfig>
  ) {
    const { clear, promotionsRequested }: WidgetDispatch = dispatch[widget.uid];

    const { hasPreloaded }: WidgetSelect = select[widget.uid];

    if (!hasPreloaded(rootState)) {
      await promotionsRequested();
    }

    const authChangeAction = authChange(actions);

    if (authChangeAction) {
      authChangeAction.pipe(takeUntil(widget.unmount)).subscribe({
        next: () => {
          promotionsRequested();
        },
        complete: clear
      });
    }
  },

  async promotionsRequested(
    _payload: undefined,
    {
      dispatch,
      request,
      rootState,
      select,
      widget
    }: WidgetEffectParams<SportsPromotionDetailsWidgetConfig>
  ) {
    const { zoneId } = widget;
    const {
      promotionDetailsLoaded,
      promotionDetailsNotFound,
      promotionDetailsLoadFailed
    }: WidgetDispatch = dispatch[widget.uid];

    if (!select.sports.isEligibleForPromotions(rootState)) {
      promotionDetailsLoaded();
      return;
    }

    try {
      const { body } = await request<PromotionDetailsResponse>({
        service: 'crm.zone',
        body: { zoneId, label: select.sports.getUrlParams(rootState).promoId }
      });

      if (body.contents?.[0]) {
        promotionDetailsLoaded(body.contents[0]);
      } else {
        promotionDetailsNotFound();
      }
    } catch (error) {
      promotionDetailsLoadFailed();
    }
  }
};
